import { render, staticRenderFns } from "./MediligoProductionCheck.vue?vue&type=template&id=62726004&scoped=true"
import script from "./MediligoProductionCheck.vue?vue&type=script&lang=js"
export * from "./MediligoProductionCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62726004",
  null
  
)

export default component.exports